import * as React from 'react'
import { Provider } from 'mobx-react'
import stores from '@/stores'
import Routes from '@/routes'

const App: React.FC = () => {
  return (
    <Provider {...stores}>
      <Routes/>
    </Provider>
  )
}

export default App